import { h } from 'preact';
export const GooglePhotosIcon = () => h("svg", {
  "aria-hidden": "true",
  focusable: "false",
  width: "32",
  height: "32",
  viewBox: "-7 -7 73 73"
}, h("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, h("path", {
  d: "M-3-3h64v64H-3z"
}), h("g", {
  "fill-rule": "nonzero"
}, h("path", {
  fill: "#FBBC04",
  d: "M14.8 13.4c8.1 0 14.7 6.6 14.7 14.8v1.3H1.3c-.7 0-1.3-.6-1.3-1.3C0 20 6.6 13.4 14.8 13.4z"
}), h("path", {
  fill: "#EA4335",
  d: "M45.6 14.8c0 8.1-6.6 14.7-14.8 14.7h-1.3V1.3c0-.7.6-1.3 1.3-1.3C39 0 45.6 6.6 45.6 14.8z"
}), h("path", {
  fill: "#4285F4",
  d: "M44.3 45.6c-8.2 0-14.8-6.6-14.8-14.8v-1.3h28.2c.7 0 1.3.6 1.3 1.3 0 8.2-6.6 14.8-14.8 14.8z"
}), h("path", {
  fill: "#34A853",
  d: "M13.4 44.3c0-8.2 6.6-14.8 14.8-14.8h1.3v28.2c0 .7-.6 1.3-1.3 1.3-8.2 0-14.8-6.6-14.8-14.8z"
}))));
export const GoogleDriveIcon = () => h("svg", {
  "aria-hidden": "true",
  focusable: "false",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, h("g", {
  fillRule: "nonzero",
  fill: "none"
}, h("path", {
  d: "M6.663 22.284l.97 1.62c.202.34.492.609.832.804l3.465-5.798H5c0 .378.1.755.302 1.096l1.361 2.278z",
  fill: "#0066DA"
}), h("path", {
  d: "M16 12.09l-3.465-5.798c-.34.195-.63.463-.832.804l-6.4 10.718A2.15 2.15 0 005 18.91h6.93L16 12.09z",
  fill: "#00AC47"
}), h("path", {
  d: "M23.535 24.708c.34-.195.63-.463.832-.804l.403-.67 1.928-3.228c.201-.34.302-.718.302-1.096h-6.93l1.474 2.802 1.991 2.996z",
  fill: "#EA4335"
}), h("path", {
  d: "M16 12.09l3.465-5.798A2.274 2.274 0 0018.331 6h-4.662c-.403 0-.794.11-1.134.292L16 12.09z",
  fill: "#00832D"
}), h("path", {
  d: "M20.07 18.91h-8.14l-3.465 5.798c.34.195.73.292 1.134.292h12.802c.403 0 .794-.11 1.134-.292L20.07 18.91z",
  fill: "#2684FC"
}), h("path", {
  d: "M23.497 12.455l-3.2-5.359a2.252 2.252 0 00-.832-.804L16 12.09l4.07 6.82h6.917c0-.377-.1-.755-.302-1.096l-3.188-5.359z",
  fill: "#FFBA00"
})));